import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { environment } from './environments/environment';

/** Karma exposes `__karma__`; skip Faro init so tests do not POST to Grafana or log fetch failures. */
function isKarmaTestRunner(): boolean {
  return typeof globalThis !== 'undefined' && '__karma__' in globalThis;
}

export function faroInitializer(): Function {
  if (isKarmaTestRunner()) {
    return async () => {
      /* no-op under Karma */
    };
  }

  return async () => {
    initializeFaro({
      url: 'https://faro-collector-prod-ca-east-0.grafana.net/collect/6a881bed5245babbc280236c3a5454f7',
      app: {
        name: 'Frontend-Passport',
        version: '2.0.0',
        environment: environment.faroEnvironment,
      },
      sessionTracking: {
        samplingRate: 1,
        persistent: true
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation(),
      ],
    });
    console.log("DEBUG: Faro Initializing");
  };

}

